import React, { Component } from "react";
import { HeaderClass, Footer } from "../../components";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Spin } from "antd";
import Styles from "./Search.module.css";
import { Image, Pagination } from "antd";
import "./Search.css";
import DIAN from "../../assets/dian.png";

const withSearch = (Children: any) => {
  return (props: any) => {
    const loaction = useLocation();
    const navigate = useNavigate();
    return <Children {...props} loaction={loaction} navigate={navigate} />;
  };
};

class SearchComponent extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      arrList: [],
      total: 20,
      page: 1,
      size: 10,
      isLoading: true,
      arr1: [],
      arr2: [],
      // id: '',
    };
  }

  itemRender = (current: any, type: any, originalElement: any) => {
    if (type === "prev") {
      return <a>上一页</a>;
    }
    if (type === "next") {
      return <a>下一页</a>;
    }
    return originalElement;
  };

  async componentDidMount() {
    window.scrollTo(0, 0);
    const { page, size } = this.state;
    this.getDataList(page, size);
    try {
      let data = {
        articleListType: 2,
      };
      const currentSessionId =
        window.sessionStorage.getItem("currentSessionId") || "";
      const res = await axios.get(
        "/api/article/page",
        {
          headers: {
            currentSessionId,
          },
          params: data,
        }
      );

      this.setState({
        arr1: res.data.data,
        isLoading: false,
      });
    } catch (error) {
      alert(error);
      this.setState({ isLoading: false });
    }
    try {
      let data = {
        articleListType: 1,
      };
      const currentSessionId =
        window.sessionStorage.getItem("currentSessionId") || "";
      const res = await axios.get(
        "/api/article/page",
        {
          headers: {
            currentSessionId,
          },
          params: data,
        }
      );

      this.setState({
        arr2: res.data.data,
        isLoading: false,
      });
    } catch (error) {
      alert(error);
      this.setState({ isLoading: false });
    }
  }

  getDataList = async (page: any, size: any) => {
    const type = this.props.loaction.state;
    const { obj, isLoading, error } = this.state;
    let id = null;
    if (type === null) {
      id = decodeURIComponent(
        this.props.loaction.pathname.split("/")[
          this.props.loaction.pathname.split("/").length - 1
        ]
      );
    } else {
      id = this.props.loaction.state.id;
    }

    try {
      let data = {
        page: page,
        size: size,
        keyword: id,
      };
      const currentSessionId =
        window.sessionStorage.getItem("currentSessionId") || "";
      // const res = await apiGet('/api/article/page', {params:data}, null, null)
      const res = await axios.get(
        "/api/article/page",
        {
          headers: {
            currentSessionId,
          },
          params: data,
        }
      );
      this.setState({
        arrList: res.data.data,
        total: res.data.recordsTotal,
        page,
        size,
        isLoading: false,
      });
    } catch (error) {
      alert(error);
      this.setState({ isLoading: false });
    }
  };

  componentWillReceiveProps(nextProps: any) {
    window.location.reload();
  }

  onChange = (page: any, pageSize: any) => {
    this.getDataList(page, pageSize);
  };

  goToDetails(id: any) {
    const { navigate } = this.props;
    return () => {
      navigate(`/details/${id}`, {
        state: { id: id, text: "" },
      });
    };
  }

  render() {
    const { arrList, total, page, size, isLoading, id, arr1, arr2 } =
      this.state;
    const { navigate } = this.props;
    if (isLoading)
      return (
        <Spin
          tip="Loading..."
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "500px",
          }}
        ></Spin>
      );
    if (!isLoading)
      return (
        <>
          <HeaderClass />
          <div
            style={{
              width: "1080px",
              margin: "0 auto",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "750px" }}>
              <div
                style={{
                  borderBottom: "3px solid #3B7FAF",
                  width: "100%",
                  lineHeight: "50px",
                  fontSize: "18px",
                  color: "#000",
                }}
              >
                "{this.props.loaction.state ? this.props.loaction.state.id : ""}
                "的搜索结果
              </div>
              {arrList.map((item: any) => {
                return (
                  <div
                    key={item.id}
                    onClick={() =>
                      navigate(`/details/${item.id}`, {
                        state: {
                          id: item.id,
                          text: this.props.loaction.state.id,
                        },
                      })
                    }
                    style={{
                      width: "100%",
                      display: "flex",
                      // alignItems: "center",
                      padding: "20px 0",
                      borderBottom: "1px solid  #999",
                    }}
                  >
                    <img
                      style={{ width: "150px", height: "100px" }}
                      src={item.img}
                      alt=""
                    />
                    <div style={{ marginLeft: "20px" }}>
                      <div
                        className={Styles["gao2_two"]}
                        style={{
                          fontSize: "18px",
                          color: "#406593",
                          cursor: "pointer",
                        }}
                      >
                        {item.title}
                      </div>
                      <div
                        className={Styles["jiga2_three"]}
                        style={{
                          fontSize: "14px",
                          color: "#000",
                          marginTop: "10px",
                          cursor: "pointer",
                        }}
                        dangerouslySetInnerHTML={{ __html: item.content }}
                      ></div>
                    </div>
                  </div>
                );
              })}

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "20px",
                }}
              >
                <Pagination
                  onChange={this.onChange}
                  pageSize={size}
                  current={page}
                  total={total}
                  itemRender={this.itemRender}
                />
              </div>
            </div>
            <div style={{ marginTop: "18px" }}>
              <div
                style={{
                  width: "300px",
                }}
              >
                <div
                  style={{
                    width: "100px",

                    background: "#005998",
                    color: "#fff",
                    padding: " 5px 10px",
                    borderBottom: "1px solid #005998",
                    borderTopRightRadius: "10px",
                    borderTopLeftRadius: "10px",
                    textAlign: "center",
                  }}
                >
                  热点新闻
                </div>
                <div
                  style={{
                    height: "330px",
                    border: "1px solid #999",
                    borderTop: "3px solid #005998",
                    padding: "5px 15px",
                  }}
                >
                  {arr1.slice(0, 8).map((item: any, index: any) => {
                    return (
                      <div
                        className="bhf2_fjo"
                        key={item.id}
                        onClick={this.goToDetails(item.id)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          borderBottom:
                            index === arr1.length - 1 ? "" : "1px solid #999",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          padding: "8px 0",
                          color: "#000",
                          fontSize: "13px",
                          cursor: "pointer",
                        }}
                      >
                        <img width={8} height={8} src={DIAN} alt="" />
                        <span style={{ marginLeft: "10px" }}>{item.title}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div
                style={{
                  width: "300px",
                  marginTop: "20px",
                }}
              >
                <div
                  style={{
                    width: "100px",

                    background: "#005998",
                    color: "#fff",
                    padding: " 5px 10px",
                    borderBottom: "1px solid #005998",
                    borderTopRightRadius: "10px",
                    borderTopLeftRadius: "10px",
                    textAlign: "center",
                  }}
                >
                  最新动态
                </div>
                <div
                  style={{
                    height: "330px",
                    border: "1px solid #999",
                    borderTop: "3px solid #005998",
                    padding: "5px 15px",
                  }}
                >
                  {arr2.slice(0, 8).map((item: any, index: any) => {
                    return (
                      <div
                        className="bhf2_fjo"
                        key={item.id}
                        onClick={this.goToDetails(item.id)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          borderBottom:
                            index === arr1.length - 1 ? "" : "1px solid #999",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          padding: "8px 0",
                          color: "#000",
                          fontSize: "13px",
                          cursor: "pointer",
                        }}
                      >
                        <img width={8} height={8} src={DIAN} alt="" />
                        <span style={{ marginLeft: "10px" }}>{item.title}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </>
      );
  }
}

export const Search = withSearch(SearchComponent);
